/**
 * ACF Blocks Version 3 - Entry Point
 * Imports all modules and initializes the block system
 */

// Import utilities.
import './blocks-v3/utils/post-locking';

// Import JSX parser and expose on acf global.
import './blocks-v3/components/jsx-parser';

// Import block registration (initializes automatically via acf.addAction).
import './blocks-v3/register-block-type-v3';
